import { render, staticRenderFns } from "./ArenaCardTitle.vue?vue&type=template&id=3cd66b05&"
import script from "./ArenaCardTitle.vue?vue&type=script&lang=js&"
export * from "./ArenaCardTitle.vue?vue&type=script&lang=js&"
import style0 from "./ArenaCardTitle.vue?vue&type=style&index=0&id=3cd66b05&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports